import axios from 'axios'

/**
 * 根据SN号获取设备项目简略信息 snHex
 */
export const getDeviceInfo = async (snHex) => {
  const { data } = await axios.get(`v2/solar-motes/get-mote-with-project-info?snHex=${snHex}`)
  return data
}

/**
 * 强制反激活设备（后面跟的是设备id）deviceId
 */
export const unactivatedById = async (deviceId) => {
  await axios.delete(`v2/solar-motes/forced-unactivated/${deviceId}`)
}
